import router from './router';
import auth from './auth';

router.beforeEach(auth);

export default router;